<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('leave_category') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i
                    class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}
            </button>
            <router-link to="/leave" class="btn btn-outline-primary btn-sm no-bor"><i
                    class="fa fa-plus-circle"></i> {{$t('new')}}
            </router-link>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-striped table-sm no-bor">
                        <thead>
                            <tr>
                                <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                                <th width="300px">{{$t('code')}}</th>
                                <th>{{$t('description')}}</th>
                                <th class="text-center">{{$t('leave_un_paid')}}</th>
                                <th class="text-center">{{$t('leave_is_bring_forward')}}</th>
                                <th class="text-center">{{$t('leave_is_unlimited')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td><router-link :to="{name: 'leave_type_update', params: {id: ret.Id}}">{{ret.Code}}</router-link></td>
                                <td>{{ret.Description}}</td>
                                <td class="text-center"><input type="checkbox" v-model="ret.UnPaid" /></td>
                                <td class="text-center"><input type="checkbox" v-model="ret.IsBringForward" /></td>
                                <td class="text-center"><input type="checkbox" v-model="ret.IsUnlimited" /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit"
                                      v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                                      hide-goto-end-buttons
                                      @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function () {
            return {
                query: {
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    Text: ''
                },
                list: []
            }
        },
        created: function () {
            this.toList();
        },
        methods: {
            toList() {
                let loading = this.$loading.show();
                this.$api().post('leaves', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Json.Leaves;
                        this.query.Total = res.data.Total;
                    }
                }).finally(function () {
                    loading.hide();
                });
            }
        }
    }
</script>